module.exports = __webpack_public_path__ + "img/expired.0462d6f2.svg";